
import { TheMask } from "vue-the-mask";

export default {
  components: { TheMask },

  props: {
    value: {
      type: String,
      default: "",
    },

    country: {
      type: String,
      default: "",
    },

    name: {
      type: String,
      default: "postal",
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      tokens: {
        A: { pattern: /[A-Za-z]/, transform: (v) => v.toUpperCase() },
        "#": { pattern: /[0-9]/ },
      },

      innerValue: this.value,
    };
  },

  watch: {
    innerValue(val) {
      this.$emit("update:value", val);
    },

    country() {
      this.innerValue = "";
    },

    value(val) {
      this.innerValue = val;
    },
  },

  computed: {
    getCleanCountry() {
      return this.country?.trim()?.toLowerCase();
    },

    mask() {
      switch (this.getCleanCountry) {
        case "canada":
          return ["A#A #A#"];
        case "usa":
          return ["#####", "#####-####"];
        default:
          return null;
      }
    },

    placeholder() {
      switch (this.getCleanCountry) {
        case "canada":
          return ["A1A 1A1"];
        case "usa":
          return ["12345", "12345-1234"];
        default:
          return "Zip/Postal Code";
      }
    },
  },
};
